// extracted by mini-css-extract-plugin
export default {"section":"DashboardLayout_section__MV+kv"};